"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeserializationError = void 0;
class DeserializationError extends Error {
    constructor(path, message) {
        super(`Deserialization error on path=${path.toString()}: ${message}`);
    }
}
exports.DeserializationError = DeserializationError;
